'use strict';

const $ = require('jquery');
require('slick-carousel');

const SELECTORS = {
    REVIEWS: '.js-reviews'
};

function init() {
    const reviews = $(SELECTORS.REVIEWS);

    if (!reviews.length) {
        return false;
    }

    reviews.each(function() {
        $(this).slick({
          arrows: false,
          speed: 500,
          fade: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          pauseOnHover: false,
          autoplaySpeed: 5000,
          dots: true
        });
    });
}

module.exports = {
    init: init
};
